import { ArticleText } from 'ui/components/2-molecules/Article';

export const ArticleTextFeature: React.FC<Umbraco.ArticleText> = ({ content }) => <ArticleText {...content?.properties} />;
